import * as settingsPage from "./settings";
import * as sharedDocumentsPage from "./shared-documents";
import * as studentPortalPage from "./settings-student-portal";
import * as mailPage from "./settings-mail";
import * as stundenplanHubPage from "./settings-stundenplan-hub";

// Einstellungen-Hub: buendelt die verwaltungsnahen Bereiche unter dem Menuepunkt
// "Einstellungen". Die Bereiche haengen als Unterpunkte in der linken Leiste
// (gerendert von app.ts), damit der Inhalt die volle Breite behaelt; eine eigene
// Navigationsspalte daneben hat zu viel Platz gekostet.
//
// Der aktive Bereich steht im URL-Query (#/einstellungen?tab=...). Ein Klick auf einen
// Unterpunkt aendert nur den Hash, den Rest erledigt der Router in app.ts.
type Section = { id: string; label: string; render: (el: HTMLElement) => Promise<void> };

// Feature-Flags der Schule; von app.ts gesetzt, steuern optionale Bereiche.
let userFeatures: string[] = [];
export function setUserContext(features: string[]) {
  userFeatures = features || [];
}

/** Alle Bereiche in Anzeigereihenfolge: Schule, dann Stundenplan, dann Kommunikation. */
export function listSections(): Section[] {
  const sections: Section[] = [
    { id: "allgemein", label: "Allgemein", render: settingsPage.render },
  ];

  // Alle Stundenplan-Einstellungen unter einem Punkt; die Bereiche liegen dort als
  // Reiter. Nur mit gebuchtem Modul.
  if (userFeatures.includes("stundenplan")) {
    sections.push({ id: "stundenplan", label: "Stundenplan", render: stundenplanHubPage.render });
  }

  // Dokumente gehen auch an Praktikumsstellen, daher unabhaengig vom Schueler-Portal.
  sections.push({ id: "dokumente", label: "Dokumente verteilen", render: sharedDocumentsPage.render });

  // Benachrichtigungen erreichen nur Schueler im Portal. Wie beim Stundenplan: ohne
  // gebuchtes Modul kein Unterpunkt. Die Seiten selbst zeigen fuer den Fall, dass
  // das Modul waehrend der Sitzung auslaeuft, weiterhin einen Hinweis.
  if (userFeatures.includes("schuelerPortal")) {
    sections.push(
      { id: "benachrichtigungen", label: "Benachrichtigungen", render: mailPage.render },
      { id: "schueler-portal", label: "Schüler-Portal", render: studentPortalPage.render },
    );
  }

  return sections;
}

/** Aktiver Bereich aus dem URL-Query; unbekannte Werte fallen auf den ersten zurueck. */
export function activeSectionId(): string {
  const query = window.location.hash.split("?")[1] || "";
  const tab = new URLSearchParams(query).get("tab");
  const sections = listSections();
  return sections.some(s => s.id === tab) ? tab! : sections[0].id;
}

export async function render(el: HTMLElement) {
  const section = listSections().find(s => s.id === activeSectionId())!;
  await section.render(el);
}
